import { GameListenerService } from './game-listener-service';
import { GameMetricsService } from './game-metrics-service';
import { GameRunnerService } from './game-runner-service';
import { AssetCatalogueService } from 'src/games/common/phaser/game/services/asset-catalogue-service';
import { BlocksAssetType, BlocksSpriteType, BlocksTranslationsType } from '../model/blocks-types';
import { assertNever, createDimensionsMap } from 'src/games/common/helper';
import { BlocksListener } from '../blocks-listener';
import { GameTranslationService } from 'src/games/common/phaser/game/services/game-translation-service';

export class GameServices {
  public readonly assetCatalogueService: AssetCatalogueService<BlocksAssetType, BlocksSpriteType>;
  public readonly gameTranslationService: GameTranslationService<BlocksTranslationsType>;
  public readonly gameMetricsService: GameMetricsService;
  public readonly gameListenerService: GameListenerService;
  public readonly gameRunnerService: GameRunnerService;
  public readonly usingLocalDealer: boolean;

  constructor() {
    this.assetCatalogueService = new AssetCatalogueService(
      BlocksAssetType,
      GameServices.constructAssets(),
    );
    this.gameTranslationService = new GameTranslationService(
      'game.blocks',
      Object.values(BlocksTranslationsType),
    );
    this.gameMetricsService = new GameMetricsService();
    this.gameListenerService = new GameListenerService();
    this.gameRunnerService = new GameRunnerService(this.gameListenerService);

    // This is a way to enable local dealer
    this.usingLocalDealer = false;
  }

  public setGameListener(gameListener: BlocksListener) {
    this.gameListenerService.setGameListener(gameListener);
  }

  private static constructAssets() {
    return createDimensionsMap(BlocksAssetType, (value) => {
      switch (value) {
        case BlocksAssetType.BlockNormal:
          return { width: 128, height: 128 };
        case BlocksAssetType.BlockNormalHighlight:
          return { width: 128, height: 128 };
        case BlocksAssetType.BlockMultiplier:
          return { width: 128, height: 128 };
        case BlocksAssetType.BlockMultiplierHighlight:
          return { width: 128, height: 128 };
        case BlocksAssetType.StartButton:
          return { width: 564, height: 128 };
        case BlocksAssetType.PlayIcon:
          return { width: 128, height: 128 };
        default:
          assertNever(value, 'Undefined game asset');
      }
    });
  }
}
